////////// INIT & DÉCLARATION
import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
const canvas = document.querySelector('canvas.webgl')
const scene = new THREE.Scene(), scInt = new THREE.Scene(), scTek = new THREE.Scene()

const startTime = performance.now()
let previousTime = 0, currentIntersect = null
let lang = 'fr'

let hEngin = null
let hArm1 = null, hArm2 = null, hArm3 = null, hChassis = null, hChenilleD = null, hChenilleG = null, hGodet1 = null, hGodet2 = null, hRouesArD = null, hRouesArG = null, hRouesAvD = null, hRouesAvG = null, hTourelle = null, hVerin1FD = null, hVerin1FD_Flip = null, hVerin1FG = null, hVerin1FG_Flip = null, hVerin1MD = null, hVerin1MG = null, hVerin2F = null, hVerin2M = null, hVerin3F = null, hVerin3F_Flip = null, hVerin3M = null, hLimAr = null, hLimAv = null, hLimGod = null, hLimPointe = null, hSki_A1 = null, hSki_A2 = null, hSki_B1 = null, hSki_B2 = null
let Dur1DoHard = [], Dur1UpHard = [], Dur1DoSkin = [], Dur1UpSkin = [], Dur2DoHard = [], Dur2UpHard = [], Dur2DoSkin = [], Dur2UpSkin = [], Dur3DoHard = [], Dur3UpHard = [], Dur3DoSkin = [], Dur3UpSkin = [], Dur4Hard = [], Dur4Skin = [], DuritesAMasquer = []
let brhMixer = null, anim1Action = null, anim2Action = null
let hBrh = null
let hCdg000 = null, hCdg = null, hBrh_A = null, hBrh_C = null, hBrh_O = null
let path = null, oriIni = new THREE.Vector3()
const pointA = new THREE.Object3D(), pointB = new THREE.Object3D(), pointC = new THREE.Object3D(), pointD = new THREE.Object3D(), anchor0 = new THREE.Object3D(), anchor1 = new THREE.Object3D(), anchor2 = new THREE.Object3D()

let chasG = false, chasD = false, pasCG = 0, pasCD = 0
let tourG = false, tourD = false, pasTG = 0, pasTD = 0
let arm1Up = false, arm1Do = false, pas1Up = 0, pas1Do = 0
let arm2Up = false, arm2Do = false, pas2Up = 0, pas2Do = 0
let arm3Up = false, arm3Do = false, pas3Up = 0, pas3Do = 0

let chenille = [], disA = null, disB = null, disC = null, ang1Ini = null, ang2Ini = null

const vecA = new THREE.Vector3(), vecB = new THREE.Vector3()
const engin = new THREE.Object3D(), brh = new THREE.Object3D()

// Loaders
const loadingManager = new THREE.LoadingManager()
loadingManager.onError = () => { console.log('Load Error')}
loadingManager.onStart = () => { console.log('Load Start')}
loadingManager.onProgress = () => { console.log('Load Progress...')}
loadingManager.onLoad = () => {	console.log('Load Finish'), fnLoaded(), tick() }
const gltfLoader = new GLTFLoader(loadingManager)
const textureLoader = new THREE.TextureLoader()
const cubeTextureLoader = new THREE.CubeTextureLoader()

// fnLoaded
const fnLoaded = () => {
	for (let i = 0 ; i < hChenilleG.children.length ; i++ ) {
		chenille.push(hChenilleG.children[i].position.x)
		chenille.push(hChenilleG.children[i].position.y)
		chenille.push(hChenilleG.children[i].rotation.z)
	}
	disA = hGodet1.getWorldPosition(vecA).distanceTo(hGodet2.getWorldPosition(vecB))
	disB = hGodet1.getWorldPosition(vecA).distanceTo(hVerin3M.getWorldPosition(vecB))
	disC = hGodet2.getWorldPosition(vecA).distanceTo(hVerin3M.getWorldPosition(vecB))
	ang1Ini = Math.acos(((Math.pow(disA,2))+(Math.pow(disB,2))-(Math.pow(disC,2)))/(2*disA*disB))
	ang2Ini = Math.acos(((Math.pow(disA,2))+(Math.pow(disC,2))-(Math.pow(disB,2)))/(2*disA*disC))
	scene.add(engin)
	hArm3.add(brh)
	hArm1.rotation.z = Math.PI * - 0.1
	hVerin1MD.lookAt(hVerin1FD.getWorldPosition(vecA))
	hVerin1MG.lookAt(hVerin1FG.getWorldPosition(vecA))
	hVerin1FD.lookAt(hVerin1MD.getWorldPosition(vecA))
	hVerin1FG.lookAt(hVerin1MG.getWorldPosition(vecA))
}


////////// TEXTURES & MATÉRIAUX
const fnLoadTex = (fichier) => { const texture = textureLoader.load(['textures/', fichier].join('')); return texture }
const texMatcap1 = fnLoadTex('Matcap_1.png')
const texMatcap2 = fnLoadTex('Matcap_2.png')
const texMatcap3 = fnLoadTex('Matcap_3.png')
const texMatcap4 = fnLoadTex('Matcap_4.png')
const texMatcapR = fnLoadTex('Matcap_R.png')
const texMatcapG = fnLoadTex('Matcap_G.png')
const texMatcapB = fnLoadTex('Matcap_B.png')
const texMatcapN = fnLoadTex('Matcap_N.png')

const texBrh_Diff = fnLoadTex('/brh/Brh_Diff.png')
const texBrh_Norm = fnLoadTex('/brh/Brh_Norm.png')
const texBrh_Rome = fnLoadTex('/brh/Brh_Rome.png')
texBrh_Diff.flipY = false
texBrh_Norm.flipY = false
texBrh_Rome.flipY = false

const texSol_Diff = fnLoadTex('/sol/Sol_Diff.jpg')
const texSol_Norm = fnLoadTex('/sol/Sol_Norm.jpg')
const texSol_Rome = fnLoadTex('/sol/Sol_Rome.jpg')
texSol_Diff.flipY = false
texSol_Norm.flipY = false
texSol_Rome.flipY = false
texSol_Diff.wrapS = THREE.RepeatWrapping
texSol_Norm.wrapS = THREE.RepeatWrapping
texSol_Rome.wrapS = THREE.RepeatWrapping
texSol_Diff.wrapT = THREE.RepeatWrapping
texSol_Norm.wrapT = THREE.RepeatWrapping
texSol_Rome.wrapT = THREE.RepeatWrapping

const texIntAtlas1 = fnLoadTex('Int_Atlas_1.png')
const texIntAtlas2 = fnLoadTex('Int_Atlas_2.png')
const texIntAtlasA = fnLoadTex('Int_Atlas_A.png')

const matNoir = new THREE.MeshBasicMaterial({ color: 0x000000, opacity: 0, transparent: true })
const matBrh = new THREE.MeshStandardMaterial({ map: texBrh_Diff, normalMap: texBrh_Norm, roughnessMap: texBrh_Rome, metalnessMap: texBrh_Rome, metalness: 1, envMapIntensity: 2 })
const matSol = new THREE.MeshStandardMaterial({	map: texSol_Diff, normalMap: texSol_Norm, roughnessMap: texSol_Rome, metalnessMap: texSol_Rome, metalness: 1, envMapIntensity: 1 })
matSol.side = THREE.DoubleSide

const matMatcap1 = new THREE.MeshMatcapMaterial({ matcap: texMatcap1})
const matMatcap2 = new THREE.MeshMatcapMaterial({ matcap: texMatcap2})
const matMatcap3 = new THREE.MeshMatcapMaterial({ matcap: texMatcap3})
const matMatcap4 = new THREE.MeshMatcapMaterial({ matcap: texMatcap4})
const matMatcapR = new THREE.MeshMatcapMaterial({ matcap: texMatcapR})
const matMatcapG = new THREE.MeshMatcapMaterial({ matcap: texMatcapG})
const matMatcapB = new THREE.MeshMatcapMaterial({ matcap: texMatcapB})
const matMatcapN = new THREE.MeshMatcapMaterial({ matcap: texMatcapN})

const matMatcap3Sk = matMatcap3.clone()
matMatcap3Sk.skinning = true
const matMatcap4Sk = matMatcap4.clone()
matMatcap4Sk.skinning = true
const matSkin = matMatcap3.clone()
matSkin.skinning = true

const matIntAtlas1 = new THREE.MeshBasicMaterial({ map: texIntAtlas1, alphaMap: texIntAtlasA })
matIntAtlas1.transparent = true
const matIntAtlas2 = matIntAtlas1.clone()
matIntAtlas2.map = texIntAtlas2

const matFluA = new THREE.MeshBasicMaterial({ color: 0xffffff, opacity: 0.0, transparent: true, skinning: true })
const matFluB = new THREE.MeshBasicMaterial({ color: 0xffffff, opacity: 0.0, transparent: true, skinning: true })
const matFluC = new THREE.MeshBasicMaterial({ color: 0xffffff, opacity: 0.0, transparent: true, skinning: true })
const matFluG = new THREE.MeshBasicMaterial({ color: 0xffffff, opacity: 0.0, transparent: true, skinning: true })


////////// CAMERAS & CONTROLS
// Cameras
const sizes = { w: window.innerWidth, h: window.innerHeight }
const camera = new THREE.PerspectiveCamera(75, sizes.w/sizes.h, 0.1, 100)
camera.position.set(-12, 6, 10)	
scene.add(camera)
const camInt = new THREE.OrthographicCamera(-0.5, 0.5, sizes.h/sizes.w, 0, 0.5, 1.5)
camInt.position.z = 1
const camTek = camera.clone()
scTek.add(camTek)
// OrbitControl
const orbCtrl = new OrbitControls(camera, canvas)
//orbCtrl.enablePan = false
//orbCtrl.screenSpacePanning = false
orbCtrl.enableDamping = true
orbCtrl.dampingFactor = 0.07
orbCtrl.target.y = 0.5
orbCtrl.minDistance = 1
orbCtrl.maxDistance = 30
orbCtrl.maxPolarAngle = Math.PI / 2
orbCtrl.zoomSpeed = 0.5
// Resize
window.addEventListener('resize', () => {
	sizes.w = window.innerWidth
    sizes.h = window.innerHeight
    camera.aspect = sizes.w/sizes.h
    camera.updateProjectionMatrix()
    camTek.aspect = sizes.w/sizes.h
    camTek.updateProjectionMatrix()
    camInt.top = sizes.h/sizes.w
    camInt.updateProjectionMatrix()
    renderer.setSize(sizes.w, sizes.h)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
	intPanBas.scale.set( Math.min(1, 1024/sizes.w), Math.min(1, 1024/sizes.w), 1 )
	blaKah.scale.x = Math.tan(Math.PI*camTek.fov/360) * 199 * camTek.aspect
	intFlags.position.y = sizes.h/sizes.w
})
// Renderer
const renderer = new THREE.WebGLRenderer({canvas: canvas, antialias: true})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setSize(sizes.w, sizes.h)
renderer.autoClear = false


////////// LIGHT & ENVIRONMENT
const cubeBackground = cubeTextureLoader
	.setPath( 'background/' )
	.load([ 'px.jpg', 'nx.jpg', 'py.jpg', 'ny.jpg', 'pz.jpg', 'nz.jpg' ])
const cubeEnvironment = cubeTextureLoader
	.setPath( 'environment/' )
	.load([ 'px.jpg', 'nx.jpg', 'py.jpg', 'ny.jpg', 'pz.jpg', 'nz.jpg' ])
scene.background = cubeBackground
scene.environment = cubeEnvironment
scTek.environment = cubeEnvironment

const alight = new THREE.AmbientLight('#ffffff', 0.5) //	 			0.5
const dlightA = new THREE.DirectionalLight('#ffffff', 0.4) // 			0.4
const dlightB = new THREE.DirectionalLight('#C0C0FF', 0.2) // bleutée		0.2
const dlightC = new THREE.DirectionalLight('#FFC080', 0.2) // orangée		0.2
dlightA.position.set( 14 * Math.sin(Math.PI*5/6), 14, 14 * Math.cos(Math.PI*5/6) )
dlightB.position.set( 14 * Math.sin(Math.PI/6), 14, 14 * Math.cos(Math.PI/6) )
dlightC.position.set( 14 * Math.sin(Math.PI*9/6), 14, 14 * Math.cos(Math.PI*9/6) )
scene.add(alight)
scene.add(dlightA)
scene.add(dlightB)
scene.add(dlightC)

const dlightAHp = new THREE.DirectionalLightHelper(dlightA)
const dlightBHp = new THREE.DirectionalLightHelper(dlightB)
const dlightCHp = new THREE.DirectionalLightHelper(dlightC)
dlightAHp.color = new THREE.Color('#ffffff')
dlightBHp.color = new THREE.Color('#C0C0FF')
dlightCHp.color = new THREE.Color('#FFC080')
dlightAHp.update()
dlightBHp.update()
dlightCHp.update()
// scene.add(dlightAHp)
// scene.add(dlightBHp)
// scene.add(dlightCHp)

dlightA.castShadow = true
dlightA.shadow.mapSize = { x: 1024, y: 1024 }
dlightA.shadow.camera.near = 3
dlightA.shadow.camera.far = 31
dlightA.shadow.camera.top = 15
dlightA.shadow.camera.right = 15
dlightA.shadow.camera.bottom = - 10.5
dlightA.shadow.camera.left = - 15
// const shadowHp = new THREE.CameraHelper(dlightB.shadow.camera)
// scene.add(shadowHp)


////////// OBJETS
// Decor
const solGeo = new THREE.CircleGeometry(15.5, 72)
solGeo.setAttribute('uv2', new THREE.BufferAttribute(solGeo.attributes.uv.array, 2))
const sol = new THREE.Mesh(solGeo, matSol)
sol.receiveShadow = true
for ( let i = 0; i < solGeo.attributes.uv.array.length ; i++ ) { solGeo.attributes.uv.array[i] *= 3 }
sol.rotation.x = - Math.PI/2
scene.add(sol)

// Engin
gltfLoader.load('./models/engin.gltf', (gltf) => {
	engin.add(gltf.scene)
	hEngin = engin.children[0].children[0]
	hChassis = hEngin.children[0]
	hTourelle = hEngin.children[1]
	hChenilleD = hChassis.children[1]
	hChenilleG = hChassis.children[2]
	hRouesArD = hChassis.children[3]
	hRouesArG = hChassis.children[4]
	hRouesAvD = hChassis.children[5]
	hRouesAvG = hChassis.children[6]
	hArm1 = hTourelle.children[1]
	hVerin1FD = hTourelle.children[3]
	hVerin1FD_Flip = hVerin1FD.children[0]
	hVerin1FG = hTourelle.children[4]
	hVerin1FG_Flip = hVerin1FG.children[0]
	hArm2 = hArm1.children[1]
	hVerin1MD = hArm1.children[2]
	hVerin1MG = hArm1.children[3]
	hVerin2F = hArm1.children[4]
	hArm3 = hArm2.children[1]
	hGodet2 = hArm2.children[2]
	hVerin2M = hArm2.children[4]
	hVerin3F = hArm2.children[5]
	hVerin3F_Flip = hVerin3F.children[0]
	hGodet1 = hArm3.children[1]
	hLimAr = hArm3.children[2]
	hLimAv = hArm3.children[3]
	hLimGod = hGodet2.children[0]
	hLimPointe = hArm3.children[4]
	hVerin3M = hGodet1.children[1]
	hSki_A1 = hTourelle.children[2]
	hSki_A2 = hSki_A1.children[0]
	hSki_B1 = hArm2.children[3]
	hSki_B2 = hSki_B1.children[0]
	hEngin.traverse((child) => { if (child.isMesh) {
		child.castShadow = true
		if (child.userData.tags === 'matcap1') { child.material = matMatcap1 } else
		if (child.userData.tags === 'matcap2') { child.material = matMatcap2 } else
		if (child.userData.tags === 'matcap3') { child.material = matMatcap3 } else
		if (child.userData.tags === 'matcap4') { child.material = matMatcap4 } else
		if (child.userData.tags === 'matcapR') { child.material = matMatcapR } else
		if (child.userData.tags === 'matcapG') { child.material = matMatcapG } else
		if (child.userData.tags === 'matcapB') { child.material = matMatcapB } else
		if (child.userData.tags === 'matcapN') { child.material = matMatcapN }
		if (child.name.includes('Hard')) { child.material = matMatcap3
			if (child.name.includes('1Do')) { Dur1DoHard.push(child) } else
			if (child.name.includes('1Up')) { Dur1UpHard.push(child) } else
			if (child.name.includes('2Do')) { Dur2DoHard.push(child) } else
			if (child.name.includes('2Up')) { Dur2UpHard.push(child) } else
			if (child.name.includes('3Do')) { Dur3DoHard.push(child) } else
			if (child.name.includes('3Up')) { Dur3UpHard.push(child) } else
			if (child.name.includes('4Do') || child.name.includes('4Up')) { Dur4Hard.push(child) }
		} else if (child.name.includes('Skin')) { child.material = matMatcap3Sk
			if (child.name.includes('1Do')) { Dur1DoSkin.push(child) } else
			if (child.name.includes('1Up')) { Dur1UpSkin.push(child) } else
			if (child.name.includes('2Do')) { Dur2DoSkin.push(child) } else
			if (child.name.includes('2Up')) { Dur2UpSkin.push(child) } else
			if (child.name.includes('3Do')) { Dur3DoSkin.push(child) } else
			if (child.name.includes('3Up')) { Dur3UpSkin.push(child) } else
			if (child.name.includes('4Do') || child.name.includes('4Up')) { Dur4Skin.push(child) }
			if (child.name === 'DuritSkin_4Do_03' || child.name === 'DuritSkin_4Up_03' ) { DuritesAMasquer.push(child) }
		}}
	})
})
// BRH
// let fluAnim_A = new THREE.Vector3(), fluAnim_B = new THREE.Vector3(), fluAnim_C = new THREE.Vector3(), fluAnim_G = new THREE.Vector3()
gltfLoader.load('./models/brh.gltf', (gltf) => {
	brh.add(gltf.scene)
	hBrh = brh.children[0].children[0]
	hCdg000 = hBrh.children[0]
	hCdg = hCdg000.children[0]
	hBrh_A = hCdg.children[0]
	hBrh_C = hCdg.children[1]
	hBrh_O = hCdg.children[2]
	hBrh_A.traverse((child) => { 
		child.material = matBrh
		child.castShadow = true
		if(child.name === 'A_Anim1_04') { child.material = matSkin }
		if(child.name.includes('Flu_A')) { child.material = matFluA }
		if(child.name === 'Flu_B') { child.material = matFluB }
		if(child.name.includes('Flu_C')) { child.material = matFluC }
		if(child.name === 'Flu_G') { child.material = matFluG }
		// if(child.name === 'FluAnim_A') { fluAnim_A = child.position }
		// if(child.name === 'FluAnim_B') { fluAnim_B = child.position }
		// if(child.name === 'FluAnim_C') { fluAnim_C = child.position }
		// if(child.name === 'FluAnim_G') { fluAnim_G = child.position }
	})
	hBrh_C.traverse((child) => { child.material = matBrh; child.castShadow = true })
	hBrh_O.traverse((child) => { child.material = matBrh })
	hBrh.position.set(0,0,0)
	hBrh.rotation.set(0,0,0)
	brhMixer = new THREE.AnimationMixer(gltf.scene)
	anim1Action = brhMixer.clipAction(gltf.animations[0])
	anim2Action = brhMixer.clipAction(gltf.animations[1])
})
 
// BlaKah
const blaKah = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), matNoir)
blaKah.position.z = -99
blaKah.scale.x = Math.tan(Math.PI*camTek.fov/360) * 199 * camTek.aspect
blaKah.scale.y = Math.tan(Math.PI*camTek.fov/360) * 199


////////// INTERFACE
const intPanBasGeo = new THREE.PlaneGeometry(1, 0.25)
intPanBasGeo.translate( 0, 0.125, 0 )
intPanBasGeo.attributes.uv.array.set([ 0, 0.25, 1, 0.25, 0, 0, 1, 0 ])
const intPanBas = new THREE.Mesh(intPanBasGeo, matIntAtlas1)
intPanBas.scale.x = Math.min(1, 1024/sizes.w)
intPanBas.scale.y = Math.min(1, 1024/sizes.w)
scInt.add(intPanBas)

const intFlags = new THREE.AxesHelper(10)
intFlags.position.x = 0.5
intFlags.position.y = sizes.h/sizes.w
scInt.add(intFlags)
// Boutons
class Bouton {constructor( parent, uvs, posX, posY, scaX, scaY) {
	this.mesh = new THREE.Mesh(new THREE.PlaneGeometry( 1, 1 ), matIntAtlas1)
	this.mesh.geometry.attributes.uv.array.set([uvs[0], uvs[1], uvs[2], uvs[3], uvs[4], uvs[5], uvs[6], uvs[7]])
	this.mesh.scale.set( scaX/2048, scaY/2048, 1 )
	this.mesh.position.set( posX, posY, 0.001 )
	parent.add(this.mesh)
}}
const btnD = new Bouton( intPanBas, [ 0.0024, 0.3062, 0.0659, 0.3062, 0.0024, 0.2524, 0.0659, 0.2524 ], -0.439, 0.0601, 130, 110 )
const btnF = new Bouton( intPanBas, [ 0.0684, 0.3062, 0.1318, 0.3062, 0.0684, 0.2524, 0.1318, 0.2524 ], -0.3657, 0.0601, 130, 110 )
const btnE = new Bouton( intPanBas, [ 0.0024, 0.3623, 0.0659, 0.3623, 0.0024, 0.3086, 0.0659, 0.3086 ], -0.439, 0.1235, 130, 110 )
const btnR = new Bouton( intPanBas, [ 0.0684, 0.3623, 0.1318, 0.3623, 0.0684, 0.3086, 0.1318, 0.3086 ], -0.3657, 0.1235, 130, 110 )
const btnI = new Bouton( intPanBas, [ 0.1343, 0.3623, 0.1978, 0.3623, 0.1343, 0.3086, 0.1978, 0.3086 ], -0.1851, 0.1235, 130, 110 )
const btnK = new Bouton( intPanBas, [ 0.1343, 0.3062, 0.1978, 0.3062, 0.1343, 0.2524, 0.1978, 0.2524 ], -0.1851, 0.0601, 130, 110 )
const btnO = new Bouton( intPanBas, [ 0.2002, 0.3623, 0.2637, 0.3623, 0.2002, 0.3086, 0.2637, 0.3086 ], -0.1118, 0.1235, 130, 110 )
const btnL = new Bouton( intPanBas, [ 0.2002, 0.3062, 0.2637, 0.3062, 0.2002, 0.2524, 0.2637, 0.2524 ], -0.1118, 0.0601, 130, 110 )
const btnP = new Bouton( intPanBas, [ 0.2661, 0.3623, 0.3296, 0.3623, 0.2661, 0.3086, 0.3296, 0.3086 ], -0.0386, 0.1235, 130, 110 )
const btnM = new Bouton( intPanBas, [ 0.2661, 0.3062, 0.3296, 0.3062, 0.2661, 0.2524, 0.3296, 0.2524 ], -0.0386, 0.0601, 130, 110 )

const btn_ = new Bouton( intPanBas, [ 0.5767, 0.3071, 0.7612, 0.3071, 0.5767, 0.2524, 0.7612, 0.2524 ], 0, 0.2109, 378, 112 )
const btnC = new Bouton( intPanBas, [ 0.4839, 0.355, 0.5278, 0.355, 0.4839, 0.2524, 0.5278, 0.2524 ], 0.2549, 0.0918, 90, 210 )
const btnT = new Bouton( intPanBas, [ 0.5303, 0.355, 0.5742, 0.355, 0.5303, 0.2524, 0.5742, 0.2524 ], 0.3281, 0.0918, 90, 210 )
const btnU = new Bouton( intPanBas, [ 0.4077, 0.3257, 0.481, 0.3257, 0.4077, 0.2524, 0.481, 0.2524 ], 0.4341, 0.0918, 150, 150 )

const btnV = new Bouton( intPanBas, [ 0.332, 0.3257, 0.4053, 0.3257, 0.332, 0.2524, 0.4053, 0.2524 ], 0.1157, 0.0698, 150, 150 )
const btnX = new Bouton( intPanBas, [ 0.332, 0.3599, 0.3774, 0.3599, 0.332, 0.3281, 0.3774, 0.3281 ], 0.0701, 0.1345, 93, 65 )
const btnY = new Bouton( intPanBas, [ 0.3774, 0.3599, 0.4233, 0.3599, 0.3774, 0.3281, 0.4233, 0.3281 ], 0.1157, 0.1345, 94, 65 )
const btnZ = new Bouton( intPanBas, [ 0.4233, 0.3599, 0.4688, 0.3599, 0.4233, 0.3281, 0.4688, 0.3281 ], 0.1614, 0.1345, 93, 65 )
btnX.mesh.material = matIntAtlas2

// Flags
const flagFr = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), matIntAtlas1)
const flagEn = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), matIntAtlas2)
const flagDe = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), matIntAtlas2)
flagFr.geometry.attributes.uv.array.set([ 0.9487, 0.2842, 0.9976, 0.2842, 0.9487, 0.2549, 0.9976, 0.2549 ])
flagEn.geometry.attributes.uv.array.set([ 0.895, 0.2842, 0.9438, 0.2842, 0.895, 0.2549, 0.9438, 0.2549 ])
flagDe.geometry.attributes.uv.array.set([ 0.8413, 0.2842, 0.8901, 0.2842, 0.8413, 0.2549, 0.8901, 0.2549 ])
flagFr.scale.set( 0.025, 0.015, 1 )
flagEn.scale.set( 0.025, 0.015, 1 )
flagDe.scale.set( 0.025, 0.015, 1 )
flagFr.position.set( -0.085, -0.015, 0 )
flagEn.position.set( -0.055, -0.015, 0 )
flagDe.position.set( -0.025, -0.015, 0 )
intFlags.add(flagFr, flagEn, flagDe)






////////// ANIMS DECLARATIONS
const params = { 
	tek: false, tekIng: false, dem: false, demIng: false, open: false, legende: false, anim1: [1, 0.15, 0.8, 3, false],
	tekOpaBlaKah: 0, tekPcPath: 0, tekPcOrien:0, tekPcAnchors:0,
	demPc1bo: 0, demPc1ro: 0, demPc1vi: 0, demPc2bo: 0, demPc2ro: 0, demPc2vi: 0, demPc3bo: 0, demPc3ro: 0, demPc3vi: 0
}
const tekMixer = new THREE.AnimationMixer( params )

anchor0.position.z = -1.5
anchor0.rotation.x = Math.PI/180 * 20
anchor0.rotation.y = Math.PI/2
camTek.add(anchor0)

const tcodPcPath = [[ 0, 0.2, 0.4, 0.6, 0.8, 1, 1.2, 1.4, 1.6, 1.8, 2 ], [ 0, 0.021, 0.087, 0.194, 0.337, 0.5, 0.663, 0.806, 0.914, 0.979, 1 ]]
const tcodPcOrien =[[ 0.2, 1.8 ], [ 0, 1 ]]
const tcodPcAnchors =[[ 0, 1 ], [ 0, 1 ]]
const tckTekIng = new THREE.BooleanKeyframeTrack( '.tekIng', [0, 0.001], [false, true] )
const tcktekOpaBlaKah = new THREE.NumberKeyframeTrack( '.tekOpaBlaKah', [0, 0.5], [0, 0.8], THREE.InterpolateSmooth )
const tckTekPcPath = new THREE.NumberKeyframeTrack( '.tekPcPath', tcodPcPath[0], tcodPcPath[1], THREE.InterpolateSmooth )
const tckTekPcOrien = new THREE.NumberKeyframeTrack( '.tekPcOrien', tcodPcOrien[0], tcodPcOrien[1], THREE.InterpolateSmooth )
const tckTekPcAnchors = new THREE.NumberKeyframeTrack( '.tekPcAnchors', tcodPcAnchors[0], tcodPcAnchors[1] )


////////// MOUSE - KEYBOARD - ACTIONS
// Mouse
const raycaster = new THREE.Raycaster()
const mouse = new THREE.Vector2()
window.addEventListener('mousemove', (event) => { mouse.x = ((event.clientX / sizes.w) - 0.5) * 2; mouse.y = - ((event.clientY / sizes.h) - 0.5) * 2 })
window.addEventListener('pointerdown', () => { if(currentIntersect) { switch(currentIntersect.object) {
	case btnD.mesh: action('DOn'); break
	case btnF.mesh: action('FOn'); break
	case btnE.mesh: action('EOn'); break
	case btnR.mesh: action('ROn'); break
	case btnI.mesh: action('IOn'); break
	case btnK.mesh: action('KOn'); break
	case btnO.mesh: action('OOn'); break
	case btnL.mesh: action('LOn'); break
	case btnP.mesh: action('POn'); break
	case btnM.mesh: action('MOn'); break
	case btn_.mesh: action('Tek'); break
	case btnC.mesh: action('Ope'); break
	case btnT.mesh: action('Leg'); break
	case btnU.mesh: action('Dem'); break
	case btnV.mesh: action('Vit'); break
	case btnX.mesh: action('ViX'); break
	case btnY.mesh: action('ViY'); break
	case btnZ.mesh: action('ViZ'); break
	case flagFr: action('FlF'); break
	case flagEn: action('FlE'); break
	case flagDe: action('FlD'); break
}}})
window.addEventListener('pointerup', () => { action('DOf'); action('FOf'); action('EOf'); action('ROf'); action('IOf'); action('KOf'); action('OOf'); action('LOf'); action('POf'); action('MOf') })
// Keyboard
const keyDown = (event) => { switch(event.code) {
	case 'KeyD': action('DOn'); break
	case 'KeyF': action('FOn'); break
	case 'KeyE': action('EOn'); break
	case 'KeyR': action('ROn'); break
	case 'KeyI': action('IOn'); break
	case 'KeyK': action('KOn'); break
	case 'KeyO': action('OOn'); break
	case 'KeyL': action('LOn'); break
	case 'KeyP': action('POn'); break
	case 'KeyM': action('MOn'); break
	case 'Semicolon': action('MOn'); break
	case 'Space': action('Tek'); break
	case 'KeyC': action('Ope'); break
	case 'KeyT': action('Leg'); break
	case 'KeyU': action('Dem'); break
	case 'KeyV': action('Vit'); break
	case 'KeyX': action('ViX'); break
	case 'KeyY': action('ViY'); break
	case 'KeyZ': action('ViZ'); break
}}		
const keyUp = (event) => { switch(event.code) {
	case 'KeyD': action('DOf'); break
	case 'KeyF': action('FOf'); break
	case 'KeyE': action('EOf'); break
	case 'KeyR': action('ROf'); break
	case 'KeyI': action('IOf'); break
	case 'KeyK': action('KOf'); break
	case 'KeyO': action('OOf'); break
	case 'KeyL': action('LOf'); break
	case 'KeyP': action('POf'); break
	case 'KeyM': action('MOf'); break
	case 'Semicolon': action('MOf'); break
}}
document.addEventListener( 'keydown', keyDown )
document.addEventListener( 'keyup', keyUp )
// Actions
const action = (o) => { switch(o) {
	case 'DOn': chasG = true; btnD.mesh.material = matIntAtlas2; break
	case 'FOn': chasD = true; btnF.mesh.material = matIntAtlas2; break
	case 'EOn': tourG = true; btnE.mesh.material = matIntAtlas2; break
	case 'ROn': tourD = true; btnR.mesh.material = matIntAtlas2; break
	case 'IOn': actArm1Up(); break
	case 'KOn': actArm1Do(); break
	case 'OOn': actArm2Up(); break
	case 'LOn': actArm2Do(); break
	case 'POn': actArm3Up(); break
	case 'MOn': actArm3Do(); break
	case 'DOf': chasG = false; btnD.mesh.material = matIntAtlas1; break
	case 'FOf': chasD = false; btnF.mesh.material = matIntAtlas1; break
	case 'EOf': tourG = false; btnE.mesh.material = matIntAtlas1; break
	case 'ROf': tourD = false; btnR.mesh.material = matIntAtlas1; break
	case 'IOf': actArm1UpNo(); break
	case 'KOf': actArm1DoNo(); break
	case 'OOf': actArm2UpNo(); break
	case 'LOf': actArm2DoNo(); break
	case 'POf': actArm3UpNo(); break
	case 'MOf': actArm3DoNo(); break
	case 'Tek': if(!params.tekIng) { if(params.tek) {actTekNo()} else {actTek()} }; break
	case 'Ope': if(params.open) {actOpenNo()} else {actOpen()}; break
	case 'Leg': if(params.legende) {actLegNo()} else {actLeg()}; break
	case 'Dem': if(params.tek) { if(params.dem) {actAnim2Back(5)} else {actAnim2Play(5)} }; break
	case 'Vit': if(params.anim1[4]) {actAnim1Halt()} else {actAnim1Play()}; break
	case 'ViX': if(params.anim1[0]!=1) {actAnim1Mode(1)}; break
	case 'ViY': if(params.anim1[0]!=2) {actAnim1Mode(2)}; break
	case 'ViZ': if(params.anim1[0]!=3) {actAnim1Mode(3)}; break
	case 'FlF': if(lang != 'fr') {actFlagFr()}; break
	case 'FlE': if(lang != 'en') {actFlagEn()}; break
	case 'FlD': if(lang != 'de') {actFlagDe()}; break
}}


////////// ACTIONS
const actFlagFr = () => { lang = 'fr'; flagFr.material = matIntAtlas1; flagDe.material = matIntAtlas2; flagEn.material = matIntAtlas2 }
const actFlagEn = () => { lang = 'en'; flagFr.material = matIntAtlas2; flagEn.material = matIntAtlas1; flagDe.material = matIntAtlas2 }
const actFlagDe = () => { lang = 'de'; flagFr.material = matIntAtlas2; flagEn.material = matIntAtlas2; flagDe.material = matIntAtlas1 }
const actArm1Up = () => { arm1Up = true ; btnI.mesh.material = matIntAtlas2
	for(let i = 0 ; i < Dur1UpHard.length ; i++) { Dur1UpHard[i].material = matMatcap4 }
	for(let i = 0 ; i < Dur1UpSkin.length ; i++) { Dur1UpSkin[i].material = matMatcap4Sk } }
const actArm1UpNo = () => { arm1Up = false; btnI.mesh.material = matIntAtlas1
	for(let i = 0 ; i < Dur1UpHard.length ; i++) { Dur1UpHard[i].material = matMatcap3 }
	for(let i = 0 ; i < Dur1UpSkin.length ; i++) { Dur1UpSkin[i].material = matMatcap3Sk } }
const actArm1Do = () => { arm1Do = true; btnK.mesh.material = matIntAtlas2
	for(let i = 0 ; i < Dur1DoHard.length ; i++) { Dur1DoHard[i].material = matMatcap4 }
	for(let i = 0 ; i < Dur1DoSkin.length ; i++) { Dur1DoSkin[i].material = matMatcap4Sk } }
const actArm1DoNo = () => { arm1Do = false; btnK.mesh.material = matIntAtlas1
	for(let i = 0 ; i < Dur1DoHard.length ; i++) { Dur1DoHard[i].material = matMatcap3 }
	for(let i = 0 ; i < Dur1DoSkin.length ; i++) { Dur1DoSkin[i].material = matMatcap3Sk } }
const actArm2Up = () => { arm2Up = true; btnO.mesh.material = matIntAtlas2
	for(let i = 0 ; i < Dur2UpHard.length ; i++) { Dur2UpHard[i].material = matMatcap4 }
	for(let i = 0 ; i < Dur2UpSkin.length ; i++) { Dur2UpSkin[i].material = matMatcap4Sk } }
const actArm2UpNo = () => { arm2Up = false; btnO.mesh.material = matIntAtlas1
	for(let i = 0 ; i < Dur2UpHard.length ; i++) { Dur2UpHard[i].material = matMatcap3 }
	for(let i = 0 ; i < Dur2UpSkin.length ; i++) { Dur2UpSkin[i].material = matMatcap3Sk } }
const actArm2Do = () => { arm2Do = true; btnL.mesh.material = matIntAtlas2
	for(let i = 0 ; i < Dur2DoHard.length ; i++) { Dur2DoHard[i].material = matMatcap4 }
	for(let i = 0 ; i < Dur2DoSkin.length ; i++) { Dur2DoSkin[i].material = matMatcap4Sk } }
const actArm2DoNo = () => { arm2Do = false; btnL.mesh.material = matIntAtlas1
	for(let i = 0 ; i < Dur2DoHard.length ; i++) { Dur2DoHard[i].material = matMatcap3 }
	for(let i = 0 ; i < Dur2DoSkin.length ; i++) { Dur2DoSkin[i].material = matMatcap3Sk } }
const actArm3Up = () => { arm3Up = true; btnP.mesh.material = matIntAtlas2
	for(let i = 0 ; i < Dur3UpHard.length ; i++) { Dur3UpHard[i].material = matMatcap4 }
	for(let i = 0 ; i < Dur3UpSkin.length ; i++) { Dur3UpSkin[i].material = matMatcap4Sk } }
const actArm3UpNo = () => { arm3Up = false; btnP.mesh.material = matIntAtlas1
	for(let i = 0 ; i < Dur3UpHard.length ; i++) { Dur3UpHard[i].material = matMatcap3 }
	for(let i = 0 ; i < Dur3UpSkin.length ; i++) { Dur3UpSkin[i].material = matMatcap3Sk } }
const actArm3Do = () => { arm3Do = true; btnM.mesh.material = matIntAtlas2
	for(let i = 0 ; i < Dur3DoHard.length ; i++) { Dur3DoHard[i].material = matMatcap4 }
	for(let i = 0 ; i < Dur3DoSkin.length ; i++) { Dur3DoSkin[i].material = matMatcap4Sk } }
const actArm3DoNo = () => { arm3Do = false; btnM.mesh.material = matIntAtlas1
	for(let i = 0 ; i < Dur3DoHard.length ; i++) { Dur3DoHard[i].material = matMatcap3 }
	for(let i = 0 ; i < Dur3DoSkin.length ; i++) { Dur3DoSkin[i].material = matMatcap3Sk } }
const actOpen = () => { params.open = true; btnC.mesh.material = matIntAtlas2; hCdg.remove(hBrh_C); hCdg.add(hBrh_O) }
const actOpenNo = () => { params.open = false; btnC.mesh.material = matIntAtlas1; hCdg.remove(hBrh_O); hCdg.add(hBrh_C) }
const actAnim1Play = () => { params.anim1[4] = true; btnV.mesh.material = matIntAtlas2
	anim1Action.paused = false
	anim1Action.setDuration(params.anim1[params.anim1[0]])
	anim1Action.play()
	for(let i = 0 ; i < Dur4Hard.length ; i++) { Dur4Hard[i].material = matMatcap4 }
	for(let i = 0 ; i < Dur4Skin.length ; i++) { Dur4Skin[i].material = matMatcap4Sk }
}
const actAnim1Halt = () => { params.anim1[4] = false; btnV.mesh.material = matIntAtlas1
	anim1Action.halt(1)
	for(let i = 0 ; i < Dur4Hard.length ; i++) { Dur4Hard[i].material = matMatcap3 }
	for(let i = 0 ; i < Dur4Skin.length ; i++) { Dur4Skin[i].material = matMatcap3Sk }
}
const actAnim1Mode = (i) => { params.anim1[0] = i
	btnX.mesh.material = matIntAtlas1
	btnY.mesh.material = matIntAtlas1
	btnZ.mesh.material = matIntAtlas1
	anim1Action.setDuration(params.anim1[i])
	switch(i) {
		case 1: btnX.mesh.material = matIntAtlas2; break
		case 2: btnY.mesh.material = matIntAtlas2; break
		case 3: btnZ.mesh.material = matIntAtlas2; break
	}
}
const actAnim2Play = (duration) => { params.dem = true; btnU.mesh.material = matIntAtlas2
	anim2Action.setDuration(duration)
	anim2Action.paused = false
	anim2Action.clampWhenFinished = true
	anim2Action.loop = THREE.LoopOnce
	anim2Action.play()
}
const actAnim2Back = (duration) => { params.dem = false; btnU.mesh.material = matIntAtlas1
	anim2Action.setDuration(-duration)
	anim2Action.paused = false
	anim2Action.clampWhenFinished = true
	anim2Action.loop = THREE.LoopOnce
	anim2Action.play()
}
const actTek = () => { params.tek = true; btn_.mesh.material = matIntAtlas2; intPanBas.material = matIntAtlas2
	orbCtrl.enabled = false
	scTek.add( alight, dlightB, dlightA, dlightC )
	camTek.add(blaKah)
	matNoir.opacity = 0
	DuritesAMasquer[0].visible = false
	DuritesAMasquer[1].visible = false
	actOpen()
	actAnim1Mode(3)
	actAnim1Play()

	pointA.position.set(0, 0, 0); pointB.position.set(0, 0, 1); pointC.position.set(1, 0, 0); pointD.position.set(0, 0, 0)
	hCdg000.add(pointA, pointB)
	anchor0.add(pointC, pointD)
	anchor0.attach(pointA).attach(pointB)
	path = new THREE.CatmullRomCurve3([ pointA.position, pointB.position, pointC.position, pointD.position ])
	
	hCdg000.add(anchor1)
	anchor1.add(anchor2)
	anchor2.add(hCdg)
	anchor0.attach(anchor1)
	oriIni.x = anchor1.rotation.x
	oriIni.y = anchor1.rotation.y
	oriIni.z = anchor1.rotation.z
	
	const clip = new THREE.AnimationClip( 'clip', 2, [ tckTekIng, tckTekPcPath, tckTekPcOrien, tcktekOpaBlaKah ] )
	const action = tekMixer.clipAction(clip)
	action.loop = THREE.LoopOnce
	action.play()

	const clip2 = new THREE.AnimationClip( 'clip2', 2, [ tckTekPcAnchors ] )
	const action2 = tekMixer.clipAction(clip2)
	action2.clampWhenFinished = true
	action2.loop = THREE.LoopOnce
	action2.play()
}
const actTekNo = () => { params.tek = false; btn_.mesh.material = matIntAtlas1; intPanBas.material = matIntAtlas1
	if(params.dem) { actAnim2Back(2) }
	orbCtrl.enabled = true
	scene.add( alight, dlightB, dlightA, dlightC )
	camTek.remove(blaKah)
	DuritesAMasquer[0].visible = true
	DuritesAMasquer[1].visible = true
	actOpenNo()
	actAnim1Halt()
	actAnim1Mode(1)

	pointA.position.set(0, 0, 0); pointB.position.set(1, 0, 0); pointC.position.set(0, 0, 1); pointD.position.set(0, 0, 0)
	hCdg.add(pointA, pointB)
	hCdg000.add(pointC, pointD)
	hCdg000.attach(pointA).attach(pointB)
	path = new THREE.CatmullRomCurve3([ pointA.position, pointB.position, pointC.position, pointD.position ])	

	hCdg000.attach(hCdg)
	oriIni.x = hCdg.rotation.x
	oriIni.y = hCdg.rotation.y
	oriIni.z = hCdg.rotation.z

	const clip = new THREE.AnimationClip( 'clip', 2, [ tckTekIng, tckTekPcPath, tckTekPcOrien ] )
	const action = tekMixer.clipAction(clip)
	action.loop = THREE.LoopOnce
	action.play()
}
const actLeg = () => {
	params.legende = true
	btnT.mesh.material = matIntAtlas2
}
const actLegNo = () => {
	params.legende = false
	btnT.mesh.material = matIntAtlas1
}


////////// TICK
const tick = () => {
	const elapsedTime = (performance.now() - startTime) / 1000
	const dt = elapsedTime - previousTime
	camTek.position.copy(camera.position)
	camTek.quaternion.copy(camera.quaternion)
	let limitSol = 	Math.max(Math.min(hLimPointe.getWorldPosition(vecA).y, 0.5), 0) *
					Math.max(Math.min(hLimAr.getWorldPosition(vecA).y, 0.5), 0) *
					Math.max(Math.min(hLimAv.getWorldPosition(vecA).y, 0.5), 0) *
					Math.max(Math.min(hLimGod.getWorldPosition(vecA).y, 0.5), 0) * 16

	// Raycaster
	raycaster.setFromCamera(mouse, camInt)
    const intersects = raycaster.intersectObjects([ btnD.mesh, btnF.mesh, btnE.mesh, btnR.mesh, btnI.mesh, btnK.mesh, btnO.mesh, btnL.mesh, btnP.mesh, btnM.mesh, btn_.mesh, btnC.mesh, btnT.mesh, btnU.mesh, btnV.mesh, btnX.mesh, btnY.mesh, btnZ.mesh, flagFr, flagEn, flagDe ])
    if(intersects.length) { currentIntersect = intersects[0] } else { currentIntersect = null }
	// Pas
	if(chasG) { pasCG += dt * (1 - Math.pow(pasCG, 2)) * 1.5 } else { pasCG -= dt * ((-Math.pow((pasCG - 1), 2)) + 1) * 4 }
	if(chasD) { pasCD += dt * (1 - Math.pow(pasCD, 2)) * 1.5 } else { pasCD -= dt * ((-Math.pow((pasCD - 1), 2)) + 1) * 4 }
	if(tourG) { pasTG += dt * (1 - Math.pow(pasTG, 2)) * 1.5 } else { pasTG -= dt * ((-Math.pow((pasTG - 1), 2)) + 1) * 4 }
	if(tourD) { pasTD += dt * (1 - Math.pow(pasTD, 2)) * 1.5 } else { pasTD -= dt * ((-Math.pow((pasTD - 1), 2)) + 1) * 4 }
	if(arm1Up) { pas1Up += dt * (1 - Math.pow(pas1Up, 2)) * 1.5 } else { pas1Up -= dt * ((-Math.pow((pas1Up - 1), 2)) + 1) * 4 }
	if(arm1Do) { pas1Do += dt * (1 - Math.pow(pas1Do, 2)) * 1.5 } else { pas1Do -= dt * ((-Math.pow((pas1Do - 1), 2)) + 1) * 4 }
	if(arm2Up) { pas2Up += dt * (1 - Math.pow(pas2Up, 2)) * 1.5 } else { pas2Up -= dt * ((-Math.pow((pas2Up - 1), 2)) + 1) * 4 }
	if(arm2Do) { pas2Do += dt * (1 - Math.pow(pas2Do, 2)) * 1.5 } else { pas2Do -= dt * ((-Math.pow((pas2Do - 1), 2)) + 1) * 4 }
	if(arm3Up) { pas3Up += dt * (1 - Math.pow(pas3Up, 2)) * 1.5 } else { pas3Up -= dt * ((-Math.pow((pas3Up - 1), 2)) + 1) * 4 }
	if(arm3Do) { pas3Do += dt * (1 - Math.pow(pas3Do, 2)) * 1.5 } else { pas3Do -= dt * ((-Math.pow((pas3Do - 1), 2)) + 1) * 4 }
	
	// Rot Chassis & Tourelle
	if( pasTG > 0.01 || pasTD > 0.01 ) { hTourelle.rotation.y += dt * (pasTG - pasTD) * 1 }
	if( pasCG > 0.01 || pasCD > 0.01 ) { 
		const pasC = dt * (pasCG - pasCD)
		const pasChe = ((hChassis.rotation.y * 8) + 1000) %1
		for( let i = 0 ; i < 46 ; i++ ) {
			hChenilleG.children[i].position.x = chenille[i*3] * pasChe + chenille[(i*3+3)%138] * (1-pasChe)
			hChenilleG.children[i].position.y = chenille[i*3+1] * pasChe + chenille[(i*3+4)%138] * (1-pasChe)
			hChenilleG.children[i].rotation.z = chenille[i*3+2] * pasChe + chenille[(i*3+5)%138] * (1-pasChe)
			hChenilleD.children[i].position.x = chenille[i*3] * (1-pasChe) + chenille[(i*3+3)%138] * pasChe
			hChenilleD.children[i].position.y = chenille[i*3+1] * (1-pasChe) + chenille[(i*3+4)%138] * pasChe
			hChenilleD.children[i].rotation.z = chenille[i*3+2] * (1-pasChe) + chenille[(i*3+5)%138] * pasChe
		}
		hChenilleG.children[33].rotation.z = Math.PI/180 * (185 - pasChe*5)
		hChenilleD.children[33].rotation.z = Math.PI/180 * (180 + pasChe*5)
		hChassis.rotation.y += pasC * 0.3
		hTourelle.rotation.y += pasC * 0.3
		hRouesArD.rotation.z += pasC * 1.2
		hRouesArG.rotation.z += - pasC * 1.2
		hRouesAvD.rotation.z += pasC * 1.2
		hRouesAvG.rotation.z += - pasC * 1.2			
	}
	// Rot Arms 1
	if( pas1Up > 0.01 || pas1Do > 0.01 ) {
		let limit1Up = Math.min((10 * (1 + (hArm1.rotation.z + 0) / 0.7)), 1)
		hArm1.rotation.z += ( pas1Do * limitSol - pas1Up * limit1Up ) * dt * 0.3
		hSki_A1.rotation.z = hArm1.rotation.z
		hSki_A2.rotation.z = - hArm1.rotation.z/2
		hVerin1MD.lookAt(hVerin1FD.getWorldPosition(vecA))
		hVerin1MG.lookAt(hVerin1FG.getWorldPosition(vecA))
		hVerin1FD.lookAt(hVerin1MD.getWorldPosition(vecA))
		hVerin1FG.lookAt(hVerin1MG.getWorldPosition(vecA))
		hVerin1FD_Flip.rotation.z = Math.PI * ( 0.5 - 0.5 * Math.sign(
			Math.pow(hVerin1FD.getWorldPosition(vecA).x, 2) + Math.pow(vecA.z, 2) - 
			Math.pow(hVerin1MD.getWorldPosition(vecA).x, 2) - Math.pow(vecA.z, 2) ))
		hVerin1FG_Flip.rotation.z = hVerin1FD_Flip.rotation.z
	}
	// Rot Arms 2
	if( pas2Up > 0.01 || pas2Do > 0.01 ) {
		let limit2Do = Math.min((10 * (1 - (hArm2.rotation.z + 0.23) / 1.05)),1)
		let limit2Up = Math.min((10 * (1 + (hArm2.rotation.z + 0.1) / 1.05)), 1)
		const sens = Math.sign(
			Math.pow(hArm2.getWorldPosition(vecA).x, 2) + Math.pow(vecA.z, 2) - 
			Math.pow(hLimPointe.getWorldPosition(vecA).x, 2) - Math.pow(vecA.z, 2) )
		hArm2.rotation.z += ( pas2Do * limit2Do * Math.max(limitSol, sens) - pas2Up * limit2Up * Math.max(limitSol, -sens) ) * dt * 0.5
		hVerin2M.lookAt(hVerin2F.getWorldPosition(vecA))
		hVerin2F.lookAt(hVerin2M.getWorldPosition(vecA))
	}
	// Rot Arms 3
	if( pas3Up > 0.01 || pas3Do > 0.01 ) {
		let limit3Do = Math.min((10 * (1 - (hArm3.rotation.z + 0.1) / 1.375)),1)
		let limit3Up = Math.min((10 * (1 + (hArm3.rotation.z - 0.325) / 1.375)), 1)
		const sens = Math.sign(
			Math.pow(hArm3.getWorldPosition(vecA).x, 2) + Math.pow(vecA.z, 2) - 
			Math.pow(hLimPointe.getWorldPosition(vecA).x, 2) - Math.pow(vecA.z, 2) )
		
		hSki_B1.rotation.z = hArm3.rotation.z/2
		hSki_B2.rotation.z = - hArm3.rotation.z/4
		disA = hGodet1.getWorldPosition(vecA).distanceTo(hGodet2.getWorldPosition(vecB))

		hArm3.rotation.z += ( pas3Do * limit3Do * Math.max(limitSol, sens) - pas3Up * limit3Up * Math.max(limitSol, -sens) ) * dt * 0.7

		hGodet2.rotation.z = - Math.acos(((Math.pow(disA,2))+(Math.pow(disC,2))-(Math.pow(disB,2)))/(2*disA*disC)) + ang2Ini + hArm3.rotation.z/2
		hGodet1.rotation.z = Math.acos(((Math.pow(disA,2))+(Math.pow(disB,2))-(Math.pow(disC,2)))/(2*disA*disB)) - ang1Ini - hArm3.rotation.z/2
		hVerin3M.lookAt(hVerin3F.getWorldPosition(vecA))
		hVerin3F.lookAt(hVerin3M.getWorldPosition(vecA))
		hVerin3F_Flip.rotation.z = Math.PI * ( 0.5 - 0.5 * Math.sign(
			Math.pow(hVerin3M.getWorldPosition(vecA).x, 2) + Math.pow(vecA.z, 2) - 
			Math.pow(hVerin3F.getWorldPosition(vecA).x, 2) - Math.pow(vecA.z, 2) ))
	}
	// Tek
	if (params.tek) {
		if(params.tekIng) {
			matNoir.opacity = params.tekOpaBlaKah
			anchor1.position.copy(path.getPointAt(params.tekPcPath))
			anchor1.rotation.x = oriIni.x * (1 - params.tekPcOrien)
			anchor1.rotation.y = oriIni.y * (1 - params.tekPcOrien)
			anchor1.rotation.z = oriIni.z * (1 - params.tekPcOrien)
		}
		anchor2.position.x = - mouse.y * 0.1 * params.tekPcAnchors
		anchor2.position.z = - mouse.x * 0.5 * params.tekPcAnchors
		anchor2.rotation.y = - mouse.x * 0.1 * params.tekPcAnchors
		anchor2.rotation.z = - mouse.y * 0.1 * params.tekPcAnchors
	} else {
		if(params.tekIng) { 
			hCdg.position.copy(path.getPointAt(params.tekPcPath))
			hCdg.rotation.x = oriIni.x * (1 - params.tekPcOrien)
			hCdg.rotation.y = oriIni.y * (1 - params.tekPcOrien)
			hCdg.rotation.z = oriIni.z * (1 - params.tekPcOrien)
		}
	}
	// Renders
    renderer.render(scene, camera)
	if(params.tek) { renderer.clearDepth(); renderer.render(scTek, camTek) }
	renderer.clearDepth(); renderer.render(scInt, camInt)
	// End
	orbCtrl.update()
	tekMixer.update(dt)
	brhMixer.update(dt)
	previousTime = elapsedTime
	window.requestAnimationFrame(tick)
}


/*
Animation fiable des anchors
Manip du BRH en mode Tek (orbit control adapté ?)
Durites qui réapparaissent trop tôt : évènement lancé en fin d'anim ?
*/
